import Coord from "./Coord.js";

/**
 * Simple point curve Point class
 *   - plain points only have "main" set
 *   - bezier points have "left" and "right" set as control points
 * A bezier curve from p1 to p2 will consist of {p1, p1.right, p2.left, p2}
 */
class Point {
	main: Coord;
	left: Coord | null;
	right: Coord | null;

  constructor(x: number, y: number) {
    this.main = new Coord(x, y);
    this.left = null;
    this.right = null;
  }
  setLeft(x: number, y: number) {
    this.left = new Coord(x, y);
  }
  setRight(x: number, y: number) {
    this.right = new Coord(x, y);
  }
  get isPlain() {
    return this.left == null && this.right == null;
  }
  getPoint() {
    return this.main;
  }
  getLeft() {
    return this.isPlain ? this.main : this.left == null ? this.main : this.left;
  }
  getRight() {
    return this.isPlain
      ? this.main
      : this.right == null
        ? this.main
        : this.right;
  }

  isEqual(point: Point) {
    return (
      this.main.x === point.main.x &&
      this.main.y === point.main.y
    );
  }
}

export default Point;
